import React from "react";
import { useLang } from "../contexts/LanguageContext";

const MICHAEL_PORTRAIT =
  "https://customer-assets.emergentagent.com/wingman/2aaf26c1-2a07-4709-9e4e-abab64ebc2fe/attachments/8e62811134784c19a4cca3b437c0aa03_image.bin";
const NANCY_PORTRAIT =
  "https://customer-assets.emergentagent.com/wingman/2aaf26c1-2a07-4709-9e4e-abab64ebc2fe/attachments/fa2a9169548f414081957c8d888ee22a_image.bin";

export default function About() {
  const { t } = useLang();

  return (
    <div className="bg-charcoal pt-32" data-testid="page-about">
      <section className="py-16 md:py-24">
        <div className="max-w-[1480px] mx-auto px-6 lg:px-12">
          <p className="overline">{t.about.overline}</p>
          <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl text-cream leading-[1.05] mt-4 max-w-4xl">
            {t.about.title}
          </h1>
        </div>
      </section>

      {/* Intro — text only, no joint portrait */}
      <section className="pb-24 md:pb-32">
        <div className="max-w-3xl mx-auto px-6 lg:px-12">
          <p className="text-cream text-lg md:text-xl leading-relaxed font-light">{t.about.intro}</p>
          <span className="divider-gold mt-10" />
          <p className="text-cream-muted text-base leading-relaxed mt-10">
            {t.about.paragraph1}
          </p>
          <p className="text-cream-muted text-base leading-relaxed mt-6">
            {t.about.paragraph2}
          </p>
        </div>
      </section>

      {/* Michael */}
      <section className="py-24 md:py-32 bg-charcoal-surface" data-testid="about-michael">
        <div className="max-w-[1480px] mx-auto px-6 lg:px-12 grid lg:grid-cols-2 gap-16 items-center">
          <div className="prop-img-wrap aspect-[3/4] overflow-hidden">
            <img src={MICHAEL_PORTRAIT} alt="Michael CEJ Hannes" className="w-full h-full object-cover" />
          </div>
          <div>
            <p className="overline">{t.about.michaelRole}</p>
            <h2 className="font-serif text-4xl md:text-5xl text-cream leading-tight mt-3">
              {t.about.michaelTitle}
            </h2>
            <span className="divider-gold mt-7" />
            <p className="text-cream-muted text-base leading-relaxed mt-8 max-w-xl">
              {t.about.michaelBody}
            </p>
            <a href="tel:+34604134186" className="btn-gold-outline mt-10 inline-flex" data-testid="about-call-michael">
              +34 604 134 186
            </a>
          </div>
        </div>
      </section>

      {/* Nancy */}
      <section className="py-24 md:py-32" data-testid="about-nancy">
        <div className="max-w-[1480px] mx-auto px-6 lg:px-12 grid lg:grid-cols-2 gap-16 items-center">
          <div className="order-2 lg:order-1">
            <p className="overline">{t.about.nancyRole}</p>
            <h2 className="font-serif text-4xl md:text-5xl text-cream leading-tight mt-3">
              {t.about.nancyTitle}
            </h2>
            <span className="divider-gold mt-7" />
            <p className="text-cream-muted text-base leading-relaxed mt-8 max-w-xl">
              {t.about.nancyBody}
            </p>
            <a href="tel:+34613905797" className="btn-gold-outline mt-10 inline-flex" data-testid="about-call-nancy">
              +34 613 905 797
            </a>
          </div>
          <div className="prop-img-wrap aspect-[3/4] overflow-hidden order-1 lg:order-2">
            <img src={NANCY_PORTRAIT} alt="Nancy C. Hannes" className="w-full h-full object-cover" />
          </div>
        </div>
      </section>
    </div>
  );
}
